import { render, staticRenderFns } from "./AppPortadaBuscadorFiltro.vue?vue&type=template&id=fc973350&"
import script from "./AppPortadaBuscadorFiltro.vue?vue&type=script&lang=js&"
export * from "./AppPortadaBuscadorFiltro.vue?vue&type=script&lang=js&"
import style0 from "./AppPortadaBuscadorFiltro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports